// this file added by Bearer Web Developer
import React from "react";
import { TReservedOrderDetails } from "../../../../../../../states/reservedOrdersState/models/reservedOrderDetails";


export const ReservedOrderInfoContext = React.createContext<TReservedOrderDetails| null>(null);